import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { isNumber } from '~/lib/math';
import { useGrid } from '../../../provider';
import DetailsModal from './details_modal';
import decPageFieldValues from './valueGetters';
const DecPageCell = (props) => {
    const { cellId, rowIndex, doc, decPageFields, descriptor } = props;
    const { anchorDoc, selectedRowIndex, setSelectedRowIndex, areCommentsVisible, modalDocument, setModalDocument, isDocModalOpen, setIsDocModalOpen, setDocBookmark, } = useGrid();
    const fieldIndex = 0;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const isActiveRow = selectedRowIndex === rowIndex;
    useEffect(() => {
        if (isDocModalOpen)
            setIsModalVisible(false);
    }, [isDocModalOpen]);
    const getCellValueFormatted = () => {
        if (!decPageFields.length)
            return React.createElement(React.Fragment, null);
        if (decPageFields.length < 2)
            return decPageFieldValues.cellValueFormatted(decPageFields[0]);
        const simpleObject = {};
        for (const field of decPageFields) {
            if (!field.subkey)
                continue;
            simpleObject[field.subkey] = field.value;
        }
        return decPageFieldValues.cellValueFormatted({
            confidenceScore: decPageFields[0].confidenceScore,
            coordinates: decPageFields[0].coordinates,
            pageNumber: decPageFields[0].pageNumber,
            value: simpleObject,
        });
    };
    const getModalValueFormatted = () => {
        if (!decPageFields.length)
            return React.createElement(React.Fragment, null);
        if (decPageFields.length < 2)
            return decPageFieldValues.modalValueFormatted(decPageFields[0]);
        const simpleObject = {};
        for (const field of decPageFields) {
            if (!field.subkey)
                continue;
            simpleObject[field.subkey] = field.value;
        }
        return decPageFieldValues.modalValueFormatted({
            confidenceScore: decPageFields[0].confidenceScore,
            coordinates: decPageFields[0].coordinates,
            pageNumber: decPageFields[0].pageNumber,
            value: simpleObject,
        });
    };
    const getAnchorModalValueFormatted = () => {
        const decPageItems = anchorDoc.data.decPageFields[descriptor.key];
        if (!decPageItems || !decPageItems.length)
            return React.createElement(React.Fragment, null);
        if (decPageItems.length < 2)
            return decPageFieldValues.modalValueFormatted(decPageItems[0]);
        const simpleObject = {};
        for (const field of decPageItems) {
            if (!field.subkey)
                continue;
            simpleObject[field.subkey] = field.value;
        }
        return decPageFieldValues.modalValueFormatted({
            confidenceScore: decPageItems[0].confidenceScore,
            coordinates: decPageItems[0].coordinates,
            pageNumber: decPageItems[0].pageNumber,
            value: simpleObject,
        });
    };
    const docModalNavigate = () => {
        if (!decPageFields.length || !decPageFields[fieldIndex])
            return;
        if (!decPageFields[fieldIndex].pageNumber || !decPageFields[fieldIndex].coordinates)
            return;
        if ((modalDocument === null || modalDocument === void 0 ? void 0 : modalDocument.fileId) !== doc.fileId)
            setModalDocument(doc);
        setDocBookmark([{ annotations: [{
                        pageNum: Number(decPageFields[fieldIndex].pageNumber),
                        coordinates: decPageFields[fieldIndex].coordinates,
                        confidenceScore: decPageFields[fieldIndex].confidenceScore,
                    }] }]);
        setIsDocModalOpen(true);
    };
    const confScore = decPageFields.length ? decPageFields[fieldIndex].confidenceScore : 100;
    const rowClass = classnames('classification cell', {
        active: isActiveRow,
        'comments-visible': areCommentsVisible,
        'low-confidence': isActiveRow
            ? confScore && isNumber(confScore) && Number(confScore) < 65
            : decPageFields.some(c => (c.confidenceScore &&
                isNumber(c.confidenceScore) &&
                Number(c.confidenceScore) < 65)),
        'mid-confidence': isActiveRow
            ? confScore && isNumber(confScore) && Number(confScore) < 80
            : decPageFields.some(c => (c.confidenceScore &&
                isNumber(c.confidenceScore) &&
                Number(c.confidenceScore) < 80)),
    });
    const contentClass = classnames('clause-content', { 'minus-1': decPageFields.length < 0 });
    const hasNavigation = (decPageFields[fieldIndex] &&
        decPageFields[fieldIndex].pageNumber &&
        decPageFields[fieldIndex].coordinates);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: rowClass, "data-testid": `cell-${cellId}`, onClick: () => !isActiveRow && setSelectedRowIndex(rowIndex) },
            React.createElement("span", { className: 'cell-details-icon', onClick: () => {
                    setIsModalVisible(!isModalVisible);
                    if (isDocModalOpen)
                        setIsDocModalOpen(false);
                }, title: 'Field Details', "data-testid": `cell-expand-${cellId}`, key: `cell-expand-${cellId}` },
                React.createElement("i", { className: 'fas fa-expand-arrows-alt' })),
            isActiveRow && decPageFields.length === 1 && hasNavigation &&
                React.createElement("span", { className: 'document-navigation-icon', onClick: () => docModalNavigate(), title: 'View in Document', "data-testid": `cell-expand-${cellId}`, key: `cell-expand-${cellId}` },
                    React.createElement("i", { className: 'fas fa-file fa-fw active' })),
            React.createElement("div", { className: contentClass, "data-testid": `cell-content-${cellId}` }, getCellValueFormatted()),
            React.createElement(DetailsModal, { "data-testid": `cell-single-document-modal-${cellId}`, anchorDoc: anchorDoc, comparisonDoc: doc, descriptor: descriptor, visible: isModalVisible, onHide: () => setIsModalVisible(false), formattedCellValue: getModalValueFormatted(), anchorModelValue: getAnchorModalValueFormatted() })));
};
export default DecPageCell;
